module.exports = __webpack_public_path__ + "static/media/stars.46ae3e79.svg";